// From Stackoverflow
function getParameterByName(name, url) {
  if (!url) {
    url = window.location.href;
  }
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}
page = 1;
if(getParameterByName('page') != null){
  page = parseInt(getParameterByName('page')) + 1;
}
if (page == 1)
  page = 2;
function ScrollExecute() {
  if($(document).height() - 800 < ($(document).scrollTop() + $(window).height())) {
    more = $('#more');
    grid = $('.grid');
    if(more.length > 0 && !more.hasClass('loading-more') && more.data('page') >= page) {
      more.addClass('loading-more')
      $.ajax({
        type: 'GET',
        dataType: 'html',
        url: window.location.pathname + '?page=' + page,
        success: function(data) {
          page++;
          products = $(data).find('.grid__item');
          grid.append(products);
          more.removeClass('loading-more')
          document.dispatchEvent(new CustomEvent('load_more_ajax_success', { detail: { container: grid[0] } }))
        }
      });
    }
  }
}
$(document).ready(function() {
  $(window).scroll(function() {
    $.doTimeout('scroll', 200, ScrollExecute);
  });
});